import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectAuth } from '../redux/authSlice';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const auth = useSelector(selectAuth);

  console.log('Authentication state:', auth.isAuthenticated);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!auth.isAuthenticated) {
          console.log('User is not authenticated. Redirecting to login.');
          return <Redirect to="/" />;
        }

        console.log('User is authenticated. Rendering component.');
        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;
